import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { EnvironmentService } from './environment.service';
import { ChannelsService } from './channels.service';

@Injectable({
    providedIn: 'root'
})
export class PlaylistService {

    mediaList: any[] = [];

    constructor(
        private envService: EnvironmentService,
        private http: HttpClient,
        private channelsService: ChannelsService) 
    {
        this.channelsService.userChannels().subscribe(x => {
            if (x) {
                this.mediaList = x?.find(f => f.playlistId === 'my-watchlist')?.media;
            }
        })
    }

    hasMediaId(mediaId) {
        return this.mediaList && this.mediaList.length > 0 && this.mediaList.filter(f => (f.id ?? f.mediaId) === mediaId).length > 0;

    }

    /*getPlaylist(playlist: string): Observable<any> {
      return this.http
        .get<any>(this.envService.contentHost + '/v3/playlist/' + playlist)
        .pipe(catchError(error => {
          if (!environment.production)
            console.error('PlaylistService::Error::get', error);
          return throwError(error);
        }))
    }*/

    addToPlaylist(mediaId: number): Observable<any> {
        if (!this.mediaList) {
            this.mediaList = [];
        }
        this.mediaList.push({id: mediaId});
        return this.http
            .post<any>(this.envService.contentHost + '/v3/playlist/my-watchlist/' + mediaId, {})
            .pipe(catchError(error => {
                if (!environment.production)
                    console.error('PlaylistService::Error::post', error);
                return throwError(error);
            }));
    }

    deleteFromPlaylist(mediaId: number): Observable<any> {
        const index = this.mediaList.findIndex(f => (f.id ?? f.mediaId) == mediaId);
        if (index > -1) {
            if (index > -1) {
                this.mediaList.splice(index, 1);
            }
        }
        return this.http
            .delete<any>(this.envService.contentHost + '/v3/playlist/my-watchlist/' + mediaId, {})
            .pipe(catchError(error => {
                if (!environment.production)
                    console.error('PlaylistService::Error::post', error);
                return throwError(error);
            }));
    }

    deleteFromPlaylistNotLocally(mediaId: number): Observable<any> {
        return this.http
            .delete<any>(this.envService.contentHost + '/v3/playlist/my-watchlist/' + mediaId, {})
            .pipe(catchError(error => {
                if (!environment.production)
                    console.error('PlaylistService::Error::post', error);
                return throwError(error);
            }));
    }

    deleteFromLocal(mediaId: number) {
        const index = this.mediaList.findIndex(f => (f.id ?? f.mediaId) == mediaId);
        if (index > -1) {
            if (index > -1) {
                this.mediaList.splice(index, 1);
            }
        }
    }
}
